import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.752 16V5.814l3.343 3.341a.75.75 0 0 0 1.06-1.06L12.58 3.521a.748.748 0 0 0-1.13-.03L6.846 8.093a.75.75 0 0 0 1.06 1.061l3.347-3.345V16a.75.75 0 0 0 1.5 0M3.25 16v2.5a2.25 2.25 0 0 0 2.25 2.25h13.001a2.25 2.25 0 0 0 2.25-2.25V16a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75V16a.75.75 0 0 0-1.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }